/* /subscribe/ and the links that lead to it.

   1. Pre-tick. A ?list=<newsletter slug> link (partials/subscribe-url.hbs)
      says which list the reader came for. For someone not signed in, the
      signup form then ticks exactly that list -- Doug's rule: a newcomer from
      the blog is asked for the blog, not the Herald as well. Without ?list,
      or with a slug that matches nothing, Ghost's default (the Herald) stands.

   2. Signed in. page-subscribe.hbs renders [data-hh-member-form] instead of
      the signup: this ticks the lists they already get plus the ?list one,
      and Save sends exactly what is ticked (here unticking IS meant, because
      they can see what they have). ?hh_saved=1 comes from subscribe-carry.js
      after it added an existing reader's choice through the sign-in email.

   3. Portal's signup popup is no longer linked from the theme, but a
      #/portal/signup link can still sit in a page body or an old post. Any of
      them goes to /subscribe/ instead. Capture phase, so this runs before
      Portal's own click handler; and source.js loads before Portal, so a
      #/portal/signup URL is redirected before Portal can open on it. */
(function () {
    'use strict';

    var API = '/members/api/member/';
    var SUBSCRIBE = '/subscribe/';
    var onSubscribePage = !!document.querySelector('[data-hh-subscribe-page]');

    function param(name) {
        var m = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.search);
        return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : null;
    }

    function wantedSlugs() {
        return (param('list') || '').split(/[.,]/).filter(function (slug) {
            return /^[a-z0-9-]+$/.test(slug);
        });
    }

    function each(nodes, fn) {
        for (var i = 0; i < nodes.length; i++) {
            fn(nodes[i]);
        }
    }

    // --- 3. leftover Portal signup links ---------------------------------

    function isSignupHash(hash) {
        return /^#\/portal\/signup/.test(hash || '');
    }

    function leaveSignupHash() {
        if (!isSignupHash(window.location.hash)) {
            return;
        }
        if (onSubscribePage) {
            window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
        } else {
            window.location.replace(SUBSCRIBE);
        }
    }

    leaveSignupHash();
    window.addEventListener('hashchange', leaveSignupHash);

    document.addEventListener('click', function (event) {
        var el = event.target && event.target.closest &&
            event.target.closest('a[href*="#/portal/signup"], [data-portal^="signup"]');
        if (!el) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        if (!onSubscribePage) {
            window.location.href = SUBSCRIBE;
        }
    }, true);

    // --- 1. pre-tick the signup form -------------------------------------

    var wanted = wantedSlugs();
    each(document.querySelectorAll('form[data-members-form]'), function (form) {
        var boxes = form.querySelectorAll('[data-hh-nl-slug]');
        var matches = 0;
        each(boxes, function (box) {
            if (wanted.indexOf(box.getAttribute('data-hh-nl-slug')) !== -1) {
                matches++;
            }
        });
        if (!matches) {
            return;
        }
        each(boxes, function (box) {
            box.checked = wanted.indexOf(box.getAttribute('data-hh-nl-slug')) !== -1;
        });
    });

    // --- 2. the signed-in form -------------------------------------------

    var form = document.querySelector('[data-hh-member-form]');
    if (!form || !window.fetch) {
        return;
    }

    var boxes = form.querySelectorAll('[data-hh-nl-id]');
    var button = form.querySelector('button[type="submit"]');
    var status = form.querySelector('[data-hh-member-status]');
    var messages = form.querySelector('[data-hh-member-messages]');

    function say(key) {
        var el = messages && messages.content && messages.content.querySelector('[data-msg="' + key + '"]');
        status.textContent = el ? el.textContent : '';
    }

    function setBusy(busy) {
        each(boxes, function (box) {
            box.disabled = busy;
        });
        button.disabled = busy;
    }

    function tickFrom(member, alsoSlugs) {
        var have = (member.newsletters || []).map(function (n) {
            return n.id;
        });
        each(boxes, function (box) {
            box.checked = have.indexOf(box.getAttribute('data-hh-nl-id')) !== -1 ||
                alsoSlugs.indexOf(box.getAttribute('data-hh-nl-slug')) !== -1;
        });
    }

    function readJson(res) {
        if (res.status !== 200) {
            throw new Error('HTTP ' + res.status);
        }
        return res.json();
    }

    fetch(API, {credentials: 'same-origin'}).then(readJson).then(function (member) {
        tickFrom(member, wanted);
        setBusy(false);
        if (param('hh_saved') || param('success') === 'true') {
            say('added');
            window.history.replaceState(window.history.state, '', window.location.pathname + window.location.hash);
        }
    }, function () {
        // Signed out after the page rendered (or the API failed): Portal's own
        // panel is the fallback, and it will ask them to sign in if it must.
        status.innerHTML = '';
        var a = document.createElement('a');
        a.href = '#/portal/account/newsletters';
        var el = messages && messages.content && messages.content.querySelector('[data-msg="manage"]');
        a.textContent = el ? el.textContent : button.textContent;
        status.appendChild(a);
    });

    form.addEventListener('submit', function (event) {
        event.preventDefault();
        var ids = [];
        each(boxes, function (box) {
            if (box.checked) {
                ids.push({id: box.getAttribute('data-hh-nl-id')});
            }
        });
        setBusy(true);
        status.textContent = '';
        fetch(API, {
            method: 'PUT',
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({newsletters: ids})
        }).then(readJson).then(function (member) {
            tickFrom(member, []);
            say('saved');
        }, function () {
            say('error');
        }).then(function () {
            setBusy(false);
        });
    });
})();
